import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import JEEMainsImage from '../images/goals/jee-mains.svg';
import {useState} from 'react';
import {useToggle} from '../hooks/useToggle';
import Folder from './Folder';
import {HtmlDecode} from '../utils/handle-session'
export default function SubCategory({subcategory}) {
	
	const [showMe, setshowMe] = useToggle(false);
	return (
		<>
			<div className="sm:mb-12 mb-6 border-0 sm:rounded-none rounded-xl sm:px-0 sm:py-0 px-3 py-[15px]" id={subcategory.attributes.name}>
				<div className="flex justify-between items-center" onClick={setshowMe}>
					<h5 className="text-black font-medium sm:text-lg">{HtmlDecode(subcategory.attributes.name)}</h5>
					<i className="fas fa-chevron-down sm:hidden block text-black"></i>
				</div>
				<div className="flex-wrap -mx-3 mt-4 subjectTab" style={{display: showMe ? 'flex' : 'none'}}>
					{subcategory.attributes.topic_id.data!==null && subcategory.attributes.topic_id.data.length>0?(
						subcategory.attributes.topic_id.data.map((folder, index) => {
							if (folder.attributes.parent_id.data !== null) {
                                return;
                            }
                            return <Folder key={index} folder={folder} subcategory={subcategory.attributes} />;
						})
					):<Folder folder={{}} subcategory={subcategory.attributes} />
					}
				</div>
			</div>
		</>
	);
}
